import { useToast } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'

const DURATION_MS = 3000

export function useNotify() {
  const { notify } = useToast()
  const { t } = useI18n()

  const extractMessage = (error: any): string | undefined =>
    error?.response?.data?.error
    ?? error?.response?.data?.message
    ?? error?.response?.message
    ?? error?.message

  const notifyError = (error?: any, fallbackKey = 'common.generalFailure') => {
    notify({
      message: extractMessage(error) ?? t(fallbackKey),
      color: 'danger',
      duration: DURATION_MS,
    })
  }

  const notifySuccess = (message: string) => {
    notify({
      message,
      color: 'success',
      duration: DURATION_MS,
    })
  }

  return { notifyError, notifySuccess }
}
